// https://panda-program.com/posts/nextjs-google-analytics とnext公式を参考に。
// ただし、他の計測系のタグもまとめて入れているのでちょっとリンク元とは違って見える。
import { useRouter } from "next/router";
import Script from "next/script";
import React, { useEffect } from "react";
import { useMe } from "lib/auth";

// Script で注入した gtag / Clarity が載せる関数（型だけここで補う）
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    clarity?: (command: string, ...args: unknown[]) => void;
  }
}

const TAG_MANAGER_ID = process.env.NEXT_PUBLIC_GOOGLE_TAGMANAGER_ID || "";
const CLARITY_ID = process.env.NEXT_PUBLIC_MICROSOFT_CLARITY_ID || "";

const existsTagManagerId = TAG_MANAGER_ID !== "";
const existsClarityId = CLARITY_ID !== "";

// PVを測定する
const pageview = (path: string) => {
  window.gtag?.("config", TAG_MANAGER_ID, {
    page_path: path,
  });
};

// _app.tsx で読み込む
export const usePageView = () => {
  const router = useRouter();

  useEffect(() => {
    if (!existsTagManagerId) {
      return;
    }

    const handleRouteChange = (path: string) => {
      pageview(path);
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);
};

// https://nextjs.org/docs/basic-features/script#afterinteractive 外部Scriptの注入のdocument
export const AnalyticsTags = () => {
  const me = useMe();

  useEffect(() => {
    if (!existsClarityId || !me?.id) return;
    window.clarity?.("identify", String(me.id));
  }, [me?.id]);

  return (
    <>
      {existsTagManagerId && (
        <>
          <Script src={`https://www.googletagmanager.com/gtag/js?id=${TAG_MANAGER_ID}`} strategy="afterInteractive" />
          <Script
            id="google-analytics"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
              __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', "${TAG_MANAGER_ID}");
          `,
            }}
          />
        </>
      )}
      {existsClarityId && (
        <>
          <Script
            id="microsoft-clarity"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
              __html: `
             (function(c,l,a,r,i,t,y){
                 c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                 t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                 y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
             })(window, document, "clarity", "script", "${CLARITY_ID}");
          `,
            }}
          />
        </>
      )}
    </>
  );
};
